import React from "react";
import PropTypes from "prop-types";

export function FormField({ children, label }) {
  return (
    <div style={{ paddingBottom: "1.7em", width: "100%" }}>
      <label style={{ fontWeight: "bold", display: "block" }}>{label}</label>
      <div
        style={{
          border: "1px solid rgba(34, 36, 38, 0.15)",
          color: "rgba(0, 0, 0, 0.87)",
          borderRadius: "0.28571429rem",
          padding: "0.67857143em 1em",
          width: "100%",
        }}
      >
        {children}
      </div>
    </div>
  );
}

FormField.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

export default FormField;
